import { render, staticRenderFns } from "./HeaderMini.vue?vue&type=template&id=5ced79f5&scoped=true&"
import script from "./HeaderMini.vue?vue&type=script&lang=ts&"
export * from "./HeaderMini.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMini.vue?vue&type=style&index=0&id=5ced79f5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced79f5",
  null
  
)

export default component.exports